var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"overview-action-bar"},[_c('div',{staticClass:"overview-tab-details"},[_c('h5',{staticClass:"count-text"},[_vm._v(_vm._s(_vm.text)+":")]),_c('h5',{staticClass:"count"},[_vm._v(_vm._s(_vm.count))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }